module.exports = __webpack_public_path__ + "static/media/flûte entier couleur.144b73b4.jpg";